import Vue from 'vue'
import 'classlist-polyfill'
import 'babel-polyfill'
import VueAwesomeSwiper from 'vue-awesome-swiper/dist/ssr'
import getAccessToken from '@/util/requestToken'
import XESLog from '@/defines/XESLog'
import Cookies from 'js-cookie'
import { xAreaIdEnum } from '@/defines/XAreaId'
import { createApp } from './app'
import ProgressBar from './components/ProgressBar.vue'
import animate from 'animate.css'
import XesLoggerSDK from '@xes/xes_fe_log'
import 'swiper/dist/css/swiper.css'
import { queryComputed } from '@/defines/logParams'

const querystring = require('querystring')
const queryObj = querystring.parse(window.location.search.substring(1))
const source = queryObj['xeswx_sourceid'] || ''

Cookies.set('xeswx_sourceid', source, { domain: 'xueersi.com' })

Vue.use(animate)
Vue.prototype.$XESLog = XESLog
// https://github.com/surmon-china/vue-awesome-swiper
Vue.use(VueAwesomeSwiper)
// 日志埋点公共字段
Vue.use(XesLoggerSDK, {
  cacheUploader: {
    interval: 10,
    batch: 1
  },
  common: {
    // 必须
    eventid: 'mallwww', // 必须带eventid
    sourceid: Cookies.get('sourceId') || '',
    xes_id: Cookies.get('xesId') || '',
    stu_id: Cookies.get('stu_id') || ''
  },
  loadMsg: {
    open: true // 自动展现日志开关
  },
  hashchange: {
    open: true, // hashChange自动展现日志开关
    pvid: 'hash'
  },
  appid: {
    localhost: {
      appid: '1004991',
      appkey: '651549f8600025626961a0eb91dcd860'
    },
    'iii.xueersi.com': {
      appid: '1004991',
      appkey: '651549f8600025626961a0eb91dcd860'
    },
    'online.xueersi.com': {
      appid: '1000012',
      appkey: '651549f8600025626961a0eb91dcd860'
    }
  },
  network: {
    open: true,
    sample: 1
  }
})
// global progress bar
const bar = (Vue.prototype.$bar = new Vue(ProgressBar).$mount())
document.body.appendChild(bar.$el)

// a global mixin that calls `asyncData` when a route component's params change
Vue.mixin({
  beforeRouteUpdate(to, from, next) {
    const {
      query: { isLogin, isLogout, isRegister }
    } = from
    if (isLogin || isLogout || isRegister) {
      next()
      return
    }
    const { asyncData } = this.$options
    if (asyncData) {
      asyncData({
        store: this.$store,
        route: to
      })
        .then(next)
        .catch(next)
    } else {
      next()
    }
  }
})

const { app, router, store } = createApp()
// prime the store with server-initialized state.
// the state is determined during SSR and inlined in the page markup.
if (window.__INITIAL_STATE__) {
  store.replaceState(window.__INITIAL_STATE__)
}

const isCSR = !document.getElementById('app')
// 降级处理为客户端渲染
if (isCSR) {
  let appEl = document.createElement('div')
  appEl.setAttribute('id', 'app')
  document
    .querySelector('body')
    .insertBefore(appEl, document.querySelector('body').firstChild)
  const stuAreaId = Cookies.get('stu_area_id')
  let xRegion = xAreaIdEnum[stuAreaId] || 100

  // console.log('=====xRegion====', xRegion)
  store.commit('SET_COOKIES', Cookies.getJSON())
  store.commit('SET_XAREAID', xRegion)
}
// wait until router has resolved all async before hooks
// and async components...
router.onReady(() => {
  // Add router hook for handling asyncData.
  // Doing it after initial route is resolved so that we don't double-fetch
  // the data that we already have. Using router.beforeResolve() so that all
  // async components are resolved.
  router.beforeResolve(async (to, from, next) => {
    await getAccessToken({ store })
    const matched = router.getMatchedComponents(to)
    const prevMatched = router.getMatchedComponents(from)
    let diffed = false
    const activated = matched.filter((c, i) => {
      return diffed || (diffed = prevMatched[i] !== c)
    })
    const asyncDataHooks = activated.map(c => c.asyncData).filter(_ => _)

    if (!asyncDataHooks.length) {
      return next()
    }

    bar.start()
    Promise.all(asyncDataHooks.map(hook => hook({ store, route: to })))
      .then(() => {
        bar.finish()
        next()
      })
      .catch(next)
  })

  router.beforeEach((to, from, next) => {
    // bar.start()
    if ('query_computed' in to.query) {
      bar.start()
      next()
      return
    }
    const route = queryComputed(to, from)
    next(route)
  })
  router.afterEach(() => {
    bar.finish()
  })
  if (isCSR) {
    const matchedComponents = router.getMatchedComponents()
    Promise.all([
      store.dispatch('GET_REGION'),
      store.dispatch('GET_GRADES'),
      store.dispatch('GET_SUBJECTS')
      // store.dispatch('GET_NAVIGATION')
    ]).then(() => {
      Promise.all(
        matchedComponents.map(
          ({ asyncData }) =>
            asyncData &&
            asyncData({
              store,
              route: router.currentRoute
            })
        )
      ).then(() => {
        app.$mount('#app')
        if (document.querySelector('#skeleton')) {
          document.querySelector('#skeleton').remove()
        }
      })
    })
    return
  }
  // actually mount to DOM
  app.$mount('#app')
})



// WEBPACK FOOTER //
// ./src/entry-client.js